import { Component, Inject, OnInit, SecurityContext, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BrandingV2Service } from '@galaxy/partner';
import { TemplatesService } from '@vendasta/templates';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Component({
  templateUrl: './preview-email-dialog.component.html',
  styleUrls: ['./preview-email-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PreviewEmailDialogComponent implements OnInit {
  renderedTemplate$: Observable<SafeHtml>;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      partnerId: string;
      marketId: string;
      templateId: string;
      subject: string;
      heading: string;
      body: string;
      button: string;
    },
    public dialogRef: MatDialogRef<PreviewEmailDialogComponent>,
    private templatesService: TemplatesService,
    private brandingService: BrandingV2Service,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.renderedTemplate$ = this.brandingService.getBranding(this.data.partnerId, this.data.marketId).pipe(
      switchMap((branding) =>
        this.templatesService.renderTemplate('sales', this.data.templateId, {
          _link: '#',
          _heading: this.data.heading,
          _body: this.data.body.replace('{{ companyName }}', '(Company Name)'),
          _button: this.data.button,
          _branding: {
            name: branding.name,
            primary_color: branding.primaryColor,
            logo_url: branding.logoUrl,
          },
        }),
      ),
      map((renderedTemplate) =>
        this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(renderedTemplate)),
      ),
      take(1),
    );
  }
}
